<section class="main-cover ">
  <div class="bg-section">
    
  </div>
  <div class="logo ">
    <img src="images/logo.png" alt="veta logo" width="150" height="auto" />
  </div>
  <div class="title">
    <b>Derivatives<br> are <br>US</b>
  </div>
  <div class="text-center text-white main-text">
   <nz-icon nzType="arrow-right" nzTheme="outline" class="arrow-right"></nz-icon>
    <a [routerLink]="loginPath" class="text-decoration-none text-white">matrix</a>
  </div>

</section>